// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"287":"gocoinapp","636":"landing"}[chunkId] + "." + {"287":"cb8f796e","636":"cb8f796e"}[chunkId] + ".chunk.css";
};